export default __webpack_public_path__ + "static/201230-Schutzimpfung-Covid19-Formular-309a57834ad9bfa8f2a75aa6e26f78f2.pdf";